/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth-interceptor';
//import { EnsureHttpsInterceptor } from './ensure-https-interceptor';
import { HttpErrorResponseInterceptor } from './http-error-response-interceptor';
import { CacheBustingInterceptor } from './cache-busting-interceptor';
import { SpinnerInterceptor } from './spinner-interceptor';
import { UUIDInterceptor } from "./uuid-interceptor";
import { MsalInterceptor } from '@azure/msal-angular';



/** Http interceptor providers in outside-in order */
export const HttpInterceptorProviders = [

  //{ provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CacheBustingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorResponseInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UUIDInterceptor, multi: true },

];


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/